<template>
    <span>
        <a href="/notifications/bids" class="notification-link" @click="onClickBids()">
            <img src="/images/auction-blue.svg" alt="Bid notifications" width="28" />
            <b-badge v-if="unread_bids_count" :class="unread_bids_count > 9 ? 'small-text' : ''">{{unread_bids_count}}</b-badge>
        </a>
        <b-popover v-if="$refs && $refs['bids_button']" :target="bids_target" triggers="focus" placement="bottomleft" title="Bid notifications">
            <div class="notifications-popper">
                <a href="/notifications/bids" @click="onRouteClick">
                    View all
                </a>
                <template v-for="(notification, i) in bids">
                    <div v-if="notification.data.title && i < 10" class="notification">
                        <a v-if="notification.data.route" :href="notification.data.route" @click="onRouteClick(notification)">
                            <div class="title">
                                {{notification.data.title}}
                            </div>
                            <div class="message" v-if="notification.data.message">
                                {{notification.data.message}}
                            </div>
                        </a>
                        <template v-else>
                            {{notification.data.title}}
                            <div class="message" v-if="notification.data.message">
                                {{notification.data.message}}
                            </div>
                        </template>
                    </div>
                </template>
                <div v-if="!bids || bids_count.length === 0">
                    You have no notifications
                </div>
            </div>
        </b-popover>
        <a href="/notifications/bid_messages" class="notification-link" @click="onClickMsg()">
            <img src="/images/request-blue.svg" alt="Bid message notifications" width="28" />
            <b-badge v-if="unread_bid_messages_count" :class="unread_bid_messages_count > 9 ? 'small-text' : ''">{{unread_bid_messages_count}}</b-badge>
        </a>
        <b-popover v-if="$refs && $refs['message_button']" :target="messages_target" triggers="focus" placement="bottomleft" title="Bid message notifications">
            <div class="notifications-popper">
                <a href="/notifications/bid_messages" @click="onRouteClick">
                    View all
                </a>
                <template v-for="(notification, i) in bid_messages">
                    <div v-if="notification.data.title && i < 10" class="notification">
                        <a v-if="notification.data.route" :href="notification.data.route" @click="onRouteClick(notification)">
                            <div class="title">
                                {{notification.data.title}}
                            </div>
                            <div class="message" v-if="notification.data.message">
                                {{notification.data.message}}
                            </div>
                        </a>
                        <template v-else>
                            {{notification.data.title}}
                            <div class="message" v-if="notification.data.message">
                                {{notification.data.message}}
                            </div>
                        </template>
                    </div>
                </template>
                <div v-if="!bids || bids_count.length === 0">
                    You have no notifications
                </div>
            </div>
        </b-popover>
    </span>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    let timer;
    export default {
        mounted(){
            this.maybeGet()
            let timeout = 1000*60*5; // every 5 minutes
            // let timeout = 1000*5;
            timer = setInterval(this.getNotifications, timeout)
        },
        destroyed(){
            clearInterval(timer)
        },
        computed:{
            ...mapGetters({
                bids: 'notifications/bids',
                unread_bids: 'notifications/unread_bids',
                bids_count: 'notifications/bids_count',
                unread_bids_count: 'notifications/unread_bids_count',
                bid_messages: 'notifications/bid_messages',
                unread_bid_messages: 'notifications/unread_bid_messages',
                bid_messages_count: 'notifications/bid_messages_count',
                unread_bid_messages_count: 'notifications/unread_bid_messages_count',
            }),
            bids_target(){
                return this.$refs['bids_button'] ? this.$refs['bids_button'] : null
            },
            messages_target(){
                return this.$refs['message_button'] ? this.$refs['message_button'] : null
            },
        },
        methods: {
            ...mapActions({
                maybeGet: 'notifications/maybeGetNotifications',
                getNotifications: 'notifications/getNotifications',
                markRead: 'notifications/markRead',
            }),
            onRouteClick(notification){
                this.$root.$emit('bv::hide::popover')
                this.markRead([notification.id]);
            },
            onClickMsg(){
                // if (this.unread_bids_count) {
                //     let ids = this.unread_bids.map(item => item.id)
                //     this.markRead(ids);
                // }
            },
            onClickBids(){
                // if (this.unread_bid_messages_count) {
                //     let ids = this.unread_bid_messages.map(item => item.id)
                //     this.markRead(ids);
                // }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Common/Notifications.vue